import { Aircraft } from "../types";

/**
 * Type guard to check if aircraft has all required geometry fields for rendering.
 * Use this to validate aircraft before passing to components that need full geometry.
 *
 * Minimal aircraft (from AutocompleteAircraft cache) only has: id, make, model, geom, linked_to
 * Full aircraft (from fetchAircraft) also has: scaled_geom_full, pivot_point, wingspan, etc.
 */
export function isFullAircraft(
  aircraft: Partial<Aircraft> | null | undefined
): aircraft is Aircraft {
  if (!aircraft) return false;

  return (
    "id" in aircraft &&
    "scaled_geom_full" in aircraft &&
    aircraft.scaled_geom_full?.coordinates?.[0]?.length > 0 &&
    "pivot_point" in aircraft &&
    aircraft.pivot_point?.coordinates?.length > 0
  );
}

/**
 * Type for minimal aircraft data (dropdown display only)
 */
export type MinimalAircraft = Pick<
  Aircraft,
  "id" | "make" | "model" | "geom" | "linked_to"
>;
